"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaggableEntityType = void 0;
var TaggableEntityType;
(function (TaggableEntityType) {
    TaggableEntityType["Run"] = "run";
    TaggableEntityType["Project"] = "project";
    TaggableEntityType["Pipeline"] = "pipeline";
    TaggableEntityType["Dataset"] = "dataset";
    TaggableEntityType["Process"] = "process";
})(TaggableEntityType || (exports.TaggableEntityType = TaggableEntityType = {}));
